import {Race} from './Race';

export class FioConfig {

  id;
  profile: string;
  token: string;
  dateFrom: Date;

}
